<template>
  <div class="card">
    <div
      class="card-body"
    >
      <p class="card-text mb-3">
        Xml Rules
      </p>
      <div class="row">
        <div class="col-lg-6">
          <form @submit.prevent="search">
            <div
              class="form-group"
            >
              <label>Query</label>
              <input
                class="form-control"
                type="text"
                placeholder="Filter rules"
                v-model="query"
                @change="search"
              >
            </div>
          </form>
        </div>
      </div>
    </div>
    <div
      class="card-body"
      v-if="rules"
    >
      <p
        class="card-text mb-3"
        v-if="rules.length === limit"
      >
        Showing first {{ limit }} rules ...
      </p>
      <table class="table table-striped">
        <thead>
          <th>Id</th>
          <th>Type</th>
          <th>Rule</th>
          <th>Created By</th>
          <th>Created At</th>
          <th>Actions</th>
        </thead>
        <tbody>
          <tr
            v-for="rule in rules"
            :key="rule.id"
          >
            <td>{{ rule.id }}</td>
            <td>{{ rule.ruleType }}</td>
            <td>
              <pre
                style="text-align: left;"
                v-html="JSON.stringify(JSON.parse(rule.rule), null, 2)"
              />
            </td>
            <td>{{ rule.createdBy }}</td>
            <td>{{ toLocaleString( rule.createdAt ) }}</td>
            <td>
              <button
                class="btn btn-outline-secondary"
                @click="removeRule ( rule.id )"
                v-if="canRemoveRule"
              >
                remove rule
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import xmlimportsapi from '../../../xmlimportapi';
import notify from '../../../notifications';
import { hasPolicyWithAnyAction } from '../../../auth/index';
import store from '../../../store';

export default {
    data() {
        return {
            rules: null,
            query: '',
            limit: 1000
        };
    },
    async mounted() {
        this.search();
    },
    computed: {
        canRemoveRule() {
            return hasPolicyWithAnyAction( store.state.user, 'xml-import-rule:*', 'xml-import-rule:write' );
        }
    },
    methods: {
        toLocaleString( dateInString ) {
            if ( !dateInString ) {
                return '';
            }
            const date = new Date( dateInString );
            return date.toLocaleString( [ 'es-ES', 'en-UK' ] );
        },
        async search() {
            this.$store.dispatch( 'appLoading', true );

            var url = `/rule?limit=${this.limit}&query=${this.query}`;

            const response = await xmlimportsapi.get( url );

            this.$store.dispatch( 'appLoading', false );

            if ( response.status !== 200 ) {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to load rules'
                } );
                return;
            }

            const responseJson = await response.json();

            this.rules = responseJson;
        },
        async removeRule( ruleId ) {
            var r = confirm( 'Are you sure you want to remove rule?' );

            if ( !r ) {
                return;
            }

            var url = '/rule/' + ruleId;

            const response = await xmlimportsapi.delete( url );

            if ( response.status !== 200 ) {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to remove rule'
                } );
                return;
            }

            notify( {
                type: 'info',
                title: 'Rule was removed'
            } );

            this.search();
        }
    }
};
</script>




// WEBPACK FOOTER //
// src/components/dashboard/xmlimport/rules.vue